'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _config = require('./config');

exports.default = function (breakpoint) {
    if (breakpoint) {
        return breakpoint;
    }
    var width = window.innerWidth;
    return _config.config.filter(function (c) {
        return width >= c.min && width <= c.max;
    })[0];
}; // TODO: remove this code when browser bugs are fixed
// https://bugs.chromium.org/p/chromium/issues/detail?id=667800


//////////////////
// WEBPACK FOOTER
// ./~/rp-mq-breakpoints/lib/high-DPI-workaround.js
// module id = 2163
// module chunks = 1